import { Base64 } from 'js-base64'

export function encrypt(jsonObj) {
    // console.log('需要加密的参数')
    // console.log(jsonObj)
    if (jsonObj instanceof Object) {
        const jsonStr = JSON.stringify(jsonObj)
        const oneStep = getOneStepData(jsonStr)
        const twoStep = getTwoStepData(jsonStr)

        const data =  oneStep + twoStep
        return data
    } else {
        console.error('该数据不适合加密')
    }
    return jsonObj
}

function getOneStepData(jsonStr) {
    let len = jsonStr.length.toString()
    const lenNumber = len.length

    for (let i = 10 - lenNumber; i > 0; i--) {
        len = '0' + len
    }
    
    return len
}

function getTwoStepData(jsonStr) {
    let value = Base64.encode(jsonStr)
    let valueArray = value.split('')

    for (let i = 0; i < Math.floor((jsonStr.length / 100) + 1); i++) {
        valueArray.splice(100 * i + 1, 0, Math.floor(Math.random() * 10))
    }

    return  valueArray.join('')
}

export function unencrypt(jsonStr) {
    const orignStrLen = Number(jsonStr.substr(0, 10))
    const value1 = jsonStr.substr(10)
    let value2 = value1.split('')
    
    let t = 0
    for (let i = 0; i < (Math.floor(orignStrLen / 100) + 1); i++) {
        value2.splice((100 * i + 1) - t, 1)
        t++
    }

    const val1 = Base64.decode(value2.join(''))
    const val2 = JSON.parse(val1)
    return val2
}

